import { ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Center, Flex, Icon, Spinner, Text } from "@chakra-ui/react";
import { Organization, organizationRepository } from "api/organizationRepository";
import { useAuth } from "contexts/authContext";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import OrgDetailsPanel from "./Component/OrgDetailsPanel";

export default function OrgDetail() {
  const location = useLocation();
  const { user, role, orgId } = useAuth();
  const orgIdFromState = (location.state as { orgId?: string })?.orgId;
  const allowrole = role?.toLowerCase() || "";

  const isRestrictedUser =
    allowrole === "orgadmin" ||
    allowrole === "locationadmin" ||
    allowrole === "deptuser";

  const effectiveOrgId = isRestrictedUser
    ? user?.orgId
    : orgIdFromState;

  const [organization, setOrganization] = useState<Organization | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchOrganization() {
      try {
        if (!effectiveOrgId) {
          setError("Organization ID missing.");
          setLoading(false);
          return;
        }

        const orgData = await organizationRepository.getOrganizationById(effectiveOrgId);
        if (orgData) {
          setOrganization(orgData);
        } else {
          setError("Organization not found.");
        }
      } catch (err) {
        setError("Failed to fetch organization data.");
      } finally {
        setLoading(false);
      }
    }

    fetchOrganization();
  }, [effectiveOrgId]);

  if (loading)
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );

  if (error || !organization)
    return (
      <Center h="100vh">
        <Text color="red.500" fontSize="lg">
          {error || "No organization data available."}
        </Text>
      </Center>
    );

  return (
    <Box p={{ base: 4, md: 6 }} pt="90px" w="100%">
      <Flex justify="space-between" align="center" mb={6} wrap="wrap" gap={4}>
        <Box>
          <Flex fontSize="sm" color="gray.500" align="center" gap="1">
            <Text>Dashboard</Text>
            <Icon as={ChevronRightIcon} />
            <Text>Organizations</Text>
            <Icon as={ChevronRightIcon} />
            <Text>{organization.name}</Text>
          </Flex>
        </Box>
      </Flex>

      <OrgDetailsPanel organization={organization} />
    </Box>
  );
}
